<template>
  <div class="home">
    <div class="mainHead" v-show="!showHeader">
      <div class="head">
        <div class="headLeft" @click="toHome()">
          <!-- <img src="./../assets/headlogo.png" alt="" /> -->
          <div>区块链浏览器</div>
        </div>
        <div class="headRight">
          <el-dropdown>
            <div style="color: black; height: 35px; line-height: 40px">
              {{ type }}<i class="el-icon-arrow-down el-icon--right"></i>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(item, index) in list"
                :key="index"
                @click.native="dropdowns(item)"
                >{{ item }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
          <el-input
            :placeholder="placeholder"
            v-model="inputValue"
            class="elInput"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="search()"
              style="background-color: #dbdeed; width: 0px"
            ></el-button>
          </el-input>
        </div>
      </div>
    </div>
    <div class="contene">
      <div class="preview">
        <ul>
          <li>
            <div class="name">区块链高度</div>
            <div class="value">{{ latestBlock }}</div>
          </li>
          <div
            style="
              height: 45px;
              width: 1px;
              background-color: #fff;
              margin: auto 0px;
            "
          ></div>
          <li>
            <div class="name">交易</div>
            <div class="value">{{ txCount }}</div>
          </li>
          <div
            style="
              height: 45px;
              width: 1px;
              background-color: #fff;
              margin: auto 0px;
            "
          ></div>

          <li>
            <div class="name">节点</div>
            <div class="value">{{ peerCount }}</div>
          </li>
          <div
            style="
              height: 45px;
              width: 1px;
              background-color: #fff;
              margin: auto 0px;
            "
          ></div>

          <li>
            <div class="name">合约</div>
            <div class="value">{{ chaincodeCount }}</div>
          </li>
        </ul>
      </div>
      <!-- //pc端 -->
      <div class="echarts" v-show="equipment">
        <div class="echart">
          <div id="echarts1"></div>
        </div>
        <div class="echart">
          <div id="echarts2"></div>
        </div>
      </div>
      <div class="echarts" v-show="equipment">
        <div class="echart">
          <div id="echarts3"></div>
        </div>
        <div class="echart">
          <div id="echarts4"></div>
        </div>
      </div>
      <!-- //手机端 -->
      <div v-show="!equipment">
        <el-row>
          <el-col :span="24"
            ><div class="grid-content bg-purple-dark" id="echartsfive"></div
          ></el-col>
        </el-row>
        <el-row>
          <el-col :span="24"
            ><div class="grid-content bg-purple-dark" id="echartssix"></div
          ></el-col>
        </el-row>
        <el-row>
          <el-col :span="24"
            ><div class="grid-content bg-purple-dark" id="echartssenve"></div
          ></el-col>
        </el-row>
        <el-row>
          <el-col :span="24"
            ><div class="grid-content bg-purple-dark" id="echartseight"></div
          ></el-col>
        </el-row>
      </div>

      <div class="table">
        <!-- pc端 -->
        <div class="div" v-show="equipment">
          <el-select
            @change="getDataList()"
            v-model="tableType"
            placeholder="请选择表"
            style="width: 100px; margin-left: 20px"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <div>
            <el-date-picker
              style="margin-left: 20px; width: 75%"
              v-model="value1"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
            <el-button
              @click="getDataList()"
              style="
                margin-left: 10px;
                background-color: #9494d3;
                color: #fff;
                border-color: transparent;
              "
            >
              查询
            </el-button>
          </div>
        </div>
        <!-- 手机端 -->
        <div class="tel" v-show="!equipment">
          <el-select
            @change="getDataList()"
            v-model="tableType"
            placeholder="请选择表"
            style="width: 140px"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <div>
            <el-date-picker
              style="width: 70%"
              v-model="value1"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              popper-class="pick-time"
              value-format="yyyy-MM-dd HH:mm:ss"
              size="mini"
            >
            </el-date-picker>
            <el-button
              @click="getDataList()"
              style="
                margin-left: 5px;
                background-color: #9494d3;
                color: #fff;
                border-color: transparent;
              "
            >
              查询
            </el-button>
          </div>
        </div>
        <el-table
          :data="tableData"
          style="width: 100%; margin: 10px 0px 10px 0px"
        >
          <el-table-column width="20">
            <div class="yuan"></div>
          </el-table-column>
          <el-table-column
            prop="to_user_address"
            header-align="center"
            align="center"
            :show-overflow-tooltip="true"
            label="用户"
            width="180"
          >
          </el-table-column>

          <el-table-column
            prop="token_name"
            header-align="center"
            align="center"
            :show-overflow-tooltip="true"
            label="存证名称"
            width="180"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.token_name">{{
                scope.row.token_name.replace(/中钞/g, "融权")
              }}</span>
            </template>
          </el-table-column>
          <!--                    <el-table-column-->
          <!--                            prop="channelname"-->
          <!--                            header-align="center"-->
          <!--                            align="center"-->
          <!--                            label="通道号"-->
          <!--                            width="180">-->
          <!--                    </el-table-column>-->
          <el-table-column
            prop="chain_tx_id"
            header-align="center"
            align="center"
            :show-overflow-tooltip="true"
            label="交易哈希"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="getTransaction(scope.row.chain_tx_id, scope.row.type)"
                >{{ scope.row.chain_tx_id }}</el-button
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="type"
            header-align="center"
            align="center"
            label="类型"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.type == '1'">新增</span>
              <span v-if="scope.row.type == '2'">转赠</span>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            :show-overflow-tooltip="true"
            label="合约名称"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.contract }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="created_time"
            header-align="center"
            align="center"
            label="时间"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.created_time | dateFormate }}</span>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            :show-overflow-tooltip="true"
            label="销毁状态"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.burn === false">未销毁</span>
              <span v-if="scope.row.burn === true">已销毁</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="sizeChangeHandle"
          @current-change="currentChangeHandle"
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="limit"
          :total="total"
          :layout="layout"
          :pager-count="pagerCount"
          :small="small"
        >
        </el-pagination>
      </div>
    </div>
    <!-- pc -->
    <div v-show="equipment">
      <el-dialog
        title="交易详情"
        :modal="false"
        :visible.sync="dialogTableVisible"
      >
        <el-descriptions title="" :column="1" border v-if="transactionId">
          <el-descriptions-item label="交易哈希">
            {{ transactionId }}
          </el-descriptions-item>
          <el-descriptions-item label="状态">
            <span v-if="status == 0">待上链</span>
            <span v-if="status == 1">上链成功</span>
            <span v-if="status == 2">上链失败</span>
          </el-descriptions-item>
          <el-descriptions-item label="存证编号">{{
            tokenId
          }}</el-descriptions-item>
          <el-descriptions-item label="存证名称">{{
            owner.replace(/中钞/g, "融权")
          }}</el-descriptions-item>
          <el-descriptions-item label="时间">{{
            createdt | dateFormate
          }}</el-descriptions-item>
          <el-descriptions-item label="存证">
            <img :src="tokenURL" alt="" height="300" />
          </el-descriptions-item>
          <el-descriptions-item label="销毁状态">
            <span v-if="burn == false">未销毁</span>
            <span v-if="burn == true">已销毁</span>
          </el-descriptions-item>
        </el-descriptions>
        <div v-if="!transactionId">暂无数据</div>
      </el-dialog>
    </div>
    <!-- 手机 -->
    <div v-show="!equipment">
      <el-dialog
        title="交易详情"
        :modal="false"
        v-show="!equipment"
        :visible.sync="dialogTableVisible"
        width="100%"
      >
        <el-descriptions title="" :column="1" border v-if="transactionId">
          <el-descriptions-item label="交易哈希">
            {{ transactionId }}
          </el-descriptions-item>
          <el-descriptions-item label="状态">
            <span v-if="status == 0">待上链</span>
            <span v-if="status == 1">上链成功</span>
            <span v-if="status == 2">上链失败</span>
          </el-descriptions-item>
          <el-descriptions-item label="存证编号">{{
            tokenId
          }}</el-descriptions-item>
          <el-descriptions-item label="存证名称">{{
            owner.replace(/中钞/g, "融权")
          }}</el-descriptions-item>
          <el-descriptions-item label="时间">{{
            createdt | dateFormate
          }}</el-descriptions-item>
          <el-descriptions-item label="存证">
            <img :src="tokenURL" alt="" height="300" />
          </el-descriptions-item>
          <el-descriptions-item label="销毁状态">
           <span v-if="burn == false">未销毁</span>
            <span v-if="burn == true">已销毁</span>
          </el-descriptions-item>
        </el-descriptions>

        <div v-if="!transactionId">暂无数据</div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import "../assets/timePick.scss";
import * as echarts from "echarts";
import JsonViewer from "vue-json-viewer";
import Clipboard from "clipboard";
export default {
  name: "home",
  components: {
    JsonViewer,
  },
  data() {
    return {
      //头部
      inputValue: "",
      list: ["存证编号", "交易哈希", "用户地址", "合约地址"],
      placeholder: "",
      type: "",
      //
      layout: "total, sizes, prev, pager, next, jumper",
      pagerCount: 0,
      small: false,
      value1: [],
      token: "",
      currentChannel: "",
      chaincodeCount: 0,
      latestBlock: 0,
      peerCount: 0,
      txCount: 0,
      echarts1Lable: [],
      echarts1Date: [],
      echarts2Lable: [],
      echarts2Date: [],
      echarts3Lable: [],
      echarts3Date: [],
      echarts4Lable: [],
      echarts4Date: [],
      pieData: [],
      legendData: [],
      tableData: [],
      dialogTableVisible: false,
      transactionId: "",
      validation_code: "",
      payload_proposal_hash: "",
      creator_msp_id: "",
      endorser_msp_id: "",
      chaincodename: "",
      type: "",
      createdt: "",
      read_set: "",
      write_set: "",
      tokenId: "",
      owner: "",
      tokenURL: "",
      tableType: 1,
      options: [
        {
          value: 1,
          label: "新增",
        },
        {
          value: 2,
          label: "转赠",
        },
      ],
      channelname: "",
      page: 1,
      limit: 10,
      total: 0,
      status: "",
      equipment: true,
      showHeader: true,
    };
  },
  created() {
    this.getPlaceholder();
    //
    this.getEquipment();
    this.start();

    this.getDataList();
  },
  methods: {
    toHome() {
      this.$router.push({
        name: "home",
      });
    },
    getPlaceholder() {
      this.placeholder = "请输入编号";
      this.type = this.list[0];
    },
    dropdowns(item) {
      this.placeholder = "请输入" + item;
      this.type = item;
    },
    search() {
      if (this.inputValue) {
        console.log(this.type);
        if (this.type == "交易哈希") {
          if (this.inputValue) {
            this.$router.push({
              path: "/hash-details",
              query: {
                id: this.inputValue,
              },
            });
          }
        } else if (this.type == "存证编号") {
          if (this.inputValue) {
            this.$router.push({
              path: "/evidence-details",
              query: {
                id: this.inputValue,
              },
            });
          }
        } else if (this.type == "合约地址") {
          if (this.inputValue) {
            this.$router.push({
              path: "/contract-address",
              query: {
                id: this.inputValue,
              },
            });
          }
        } else if (this.type == "用户地址") {
          if (this.inputValue) {
            this.$router.push({
              path: "/user-address",
              query: {
                id: this.inputValue,
              },
            });
          }
        }
      } else if (!this.inputValue) {
        // console.log(this.type)
        this.$message({
          message: "请输入" + this.type,
          type: "warning",
        });
      }
    },
    getToken() {
      console.log(device);
      this.$http
        .post(this.$http.baseURL + "/auth/login", {
          network: "test-network",
          password: "exploreradminpw",
          user: "exploreradmin",
        })
        .then((res) => {
          this.token = res.data.token;
          this.getcurrentChannel();
        });
    },
    getcurrentChannel() {
      this.$http
        .get(this.$http.baseURL + "/api/curChannel", {
          headers: {
            Authorization: "Bearer " + this.token,
          },
        })
        .then((res) => {
          this.currentChannel = res.data.currentChannel;
          this.start();
          // this.pieEcharts()
        });
    },
    getEquipment() {
      let equ = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      console.log(equ);
      if (equ) {
        this.equipment = false;
        this.showHeader = false;
        this.layout = "total, prev, pager, next";
        this.pagerCount = 5;
        this.small = true;
        this.lineEcharts5();
        this.lineEcharts6();
        this.lineEcharts7();
        this.lineEcharts8();
      } else {
        this.equipment = true;
        this.showHeader = true;
        this.layout = "total, sizes, prev, pager, next, jumper";
        this.pagerCount = 7;
        this.small = false;
        this.lineEcharts1();
        this.lineEcharts2();
        this.lineEcharts3();
        this.lineEcharts4();
      }
    },
    start() {
      this.$http.get(this.$http.baseURL2 + "/blockInfo").then((res) => {
        this.chaincodeCount = res.data.chaincodeCount;
        this.latestBlock = res.data.latestBlock;
        this.peerCount = res.data.peerCount;
        this.txCount = res.data.txCount;
      });
    },
    //pc端
    lineEcharts1() {
      this.$http
        .get(this.$http.baseURL2 + "/nfe/sync/tradecount")
        .then((res) => {
          for (let n = 0; n < res.data.data.list.length; n++) {
            this.echarts1Lable.push(res.data.data.list[n].count);
            this.echarts1Date.push(res.data.data.list[n].days);
          }
          this.getecharts1();
        });
    },
    getecharts1() {
      var chartDom1 = document.getElementById("echarts1");
      var myChart1 = echarts.init(chartDom1);
      var option1;
      var listener1 = function () {
        myChart1.resize();
      };
      window.addEventListener("resize", listener1);
      option1 = {
        title: {
          text: "近14天交易统计",
          subtext: "",
          left: "center",
        },
        xAxis: {
          type: "category",
          data: this.echarts1Date,
          boundaryGap: false,
        },
        yAxis: {
          type: "value",
        },
        tooltip: {
          trigger: "item", // axis   item   none三个值
        },
        series: [
          {
            data: this.echarts1Lable,
            type: "line",
            label: {
              show: true,
            },
          },
        ],
      };

      option1 && myChart1.setOption(option1);
    },
    lineEcharts2() {
      console.log("123:" + this.$http.baseURL2);
      this.$http
        .get(this.$http.baseURL2 + "/nfe/sync/usercount")
        .then((res) => {
          for (let n = 0; n < res.data.data.list.length; n++) {
            this.echarts2Lable.push(res.data.data.list[n].count);
            this.echarts2Date.push(res.data.data.list[n].days);
          }
          this.getecharts2();
        });
    },
    getecharts2() {
      var chartDom2 = document.getElementById("echarts2");
      var myChart2 = echarts.init(chartDom2);
      var option2;
      var listener2 = function () {
        myChart2.resize();
      };
      window.addEventListener("resize", listener2);
      option2 = {
        title: {
          text: "近14天用户统计",
          subtext: "",
          left: "center",
        },
        xAxis: {
          type: "category",
          data: this.echarts2Date,
          boundaryGap: false,
        },
        yAxis: {
          type: "value",
        },
        tooltip: {
          trigger: "item", // axis   item   none三个值
        },
        series: [
          {
            data: this.echarts2Lable,
            type: "line",
            label: {
              show: true,
            },
          },
        ],
      };

      option2 && myChart2.setOption(option2);
    },
    lineEcharts3() {
      this.$http
        .get(this.$http.baseURL2 + "/nfe/sync/collectionscount")
        .then((res) => {
          for (let n = 0; n < res.data.data.list.length; n++) {
            this.echarts3Lable.push(res.data.data.list[n].count);
            this.echarts3Date.push(res.data.data.list[n].days);
          }
          this.getecharts3();
        });
    },
    getecharts3() {
      var chartDom3 = document.getElementById("echarts3");
      var myChart3 = echarts.init(chartDom3);
      var option3;
      var listener3 = function () {
        myChart3.resize();
      };
      window.addEventListener("resize", listener3);
      option3 = {
        title: {
          text: "近14天存证统计",
          subtext: "",
          left: "center",
        },
        xAxis: {
          type: "category",
          data: this.echarts3Date,
          boundaryGap: false,
        },
        yAxis: {
          type: "value",
        },
        tooltip: {
          trigger: "item", // axis   item   none三个值
        },
        series: [
          {
            data: this.echarts3Lable,
            type: "line",
            label: {
              show: true,
            },
          },
        ],
      };

      option3 && myChart3.setOption(option3);
    },
    lineEcharts4() {
      this.$http
        .get(this.$http.baseURL2 + "/nfe/sync/turnoverratecount?transType=2")
        .then((res) => {
          for (let n = 0; n < res.data.data.list.length; n++) {
            this.echarts4Lable.push(res.data.data.list[n].count);
            this.echarts4Date.push(res.data.data.list[n].days);
          }
          this.getecharts4();
        });
    },
    getecharts4() {
      var chartDom4 = document.getElementById("echarts4");
      var myChart4 = echarts.init(chartDom4);
      var option4;
      var listener4 = function () {
        myChart4.resize();
      };
      window.addEventListener("resize", listener4);
      option4 = {
        title: {
          text: "近14天转赠统计",
          subtext: "",
          left: "center",
        },
        xAxis: {
          type: "category",
          data: this.echarts4Date,
          boundaryGap: false,
        },
        yAxis: {
          type: "value",
        },
        tooltip: {
          trigger: "item", // axis   item   none三个值
        },
        series: [
          {
            data: this.echarts4Lable,
            type: "line",
            label: {
              show: true,
            },
          },
        ],
      };

      option4 && myChart4.setOption(option4);
    },
    //手机端
    lineEcharts5() {
      this.$http
        .get(this.$http.baseURL2 + "/nfe/sync/tradecount")
        .then((res) => {
          for (let n = 0; n < res.data.data.list.length; n++) {
            this.echarts1Lable.push(res.data.data.list[n].count);
            this.echarts1Date.push(res.data.data.list[n].days);
          }
          this.getecharts5();
        });
    },
    getecharts5() {
      var chartDom1 = document.getElementById("echartsfive");
      var myChart1 = echarts.init(chartDom1);
      var option1;
      var listener1 = function () {
        myChart1.resize();
      };
      window.addEventListener("resize", listener1);
      option1 = {
        title: {
          text: "近14天交易统计",
          subtext: "",
          left: "center",
        },
        xAxis: {
          type: "category",
          data: this.echarts1Date,
          boundaryGap: false,
        },
        yAxis: {
          type: "value",
        },
        tooltip: {
          trigger: "item", // axis   item   none三个值
        },
        series: [
          {
            data: this.echarts1Lable,
            type: "line",
            label: {
              show: true,
            },
          },
        ],
      };

      option1 && myChart1.setOption(option1);
    },
    lineEcharts6() {
      this.$http
        .get(this.$http.baseURL2 + "/nfe/sync/usercount")
        .then((res) => {
          for (let n = 0; n < res.data.data.list.length; n++) {
            this.echarts2Lable.push(res.data.data.list[n].count);
            this.echarts2Date.push(res.data.data.list[n].days);
          }
          this.getecharts6();
        });
    },
    getecharts6() {
      var chartDom2 = document.getElementById("echartssix");
      var myChart2 = echarts.init(chartDom2);
      var option2;
      var listener2 = function () {
        myChart2.resize();
      };
      window.addEventListener("resize", listener2);
      option2 = {
        title: {
          text: "近14天用户统计",
          subtext: "",
          left: "center",
        },
        xAxis: {
          type: "category",
          data: this.echarts2Date,
          boundaryGap: false,
        },
        yAxis: {
          type: "value",
        },
        tooltip: {
          trigger: "item", // axis   item   none三个值
        },
        series: [
          {
            data: this.echarts2Lable,
            type: "line",
            label: {
              show: true,
            },
          },
        ],
      };

      option2 && myChart2.setOption(option2);
    },
    lineEcharts7() {
      this.$http
        .get(this.$http.baseURL2 + "/nfe/sync/collectionscount")
        .then((res) => {
          for (let n = 0; n < res.data.data.list.length; n++) {
            this.echarts3Lable.push(res.data.data.list[n].count);
            this.echarts3Date.push(res.data.data.list[n].days);
          }
          this.getecharts7();
        });
    },
    getecharts7() {
      var chartDom3 = document.getElementById("echartssenve");
      var myChart3 = echarts.init(chartDom3);
      var option3;
      var listener3 = function () {
        myChart3.resize();
      };
      window.addEventListener("resize", listener3);
      option3 = {
        title: {
          text: "近14天存证统计",
          subtext: "",
          left: "center",
        },
        xAxis: {
          type: "category",
          data: this.echarts3Date,
          boundaryGap: false,
        },
        yAxis: {
          type: "value",
        },
        tooltip: {
          trigger: "item", // axis   item   none三个值
        },
        series: [
          {
            data: this.echarts3Lable,
            type: "line",
            label: {
              show: true,
            },
          },
        ],
      };

      option3 && myChart3.setOption(option3);
    },
    lineEcharts8() {
      this.$http
        .get(this.$http.baseURL2 + "/nfe/sync/turnoverratecount?transType=2")
        .then((res) => {
          for (let n = 0; n < res.data.data.list.length; n++) {
            this.echarts4Lable.push(res.data.data.list[n].count);
            this.echarts4Date.push(res.data.data.list[n].days);
          }
          this.getecharts8();
        });
    },
    getecharts8() {
      var chartDom4 = document.getElementById("echartseight");
      var myChart4 = echarts.init(chartDom4);
      var option4;
      var listener4 = function () {
        myChart4.resize();
      };
      window.addEventListener("resize", listener4);
      option4 = {
        title: {
          text: "近14天转赠统计",
          subtext: "",
          left: "center",
        },
        xAxis: {
          type: "category",
          data: this.echarts4Date,
          boundaryGap: false,
        },
        yAxis: {
          type: "value",
        },
        tooltip: {
          trigger: "item", // axis   item   none三个值
        },
        series: [
          {
            data: this.echarts4Lable,
            type: "line",
            label: {
              show: true,
            },
          },
        ],
      };

      option4 && myChart4.setOption(option4);
    },
    getDataList() {
      // console.log(this.page)
      this.tableData = [];
      // console.log(this.value1)
      if (!this.value1) {
        this.value1 = [];
      }
      this.$http
        .get(this.$http.baseURL2 + "/nfe/sync/txlist", {
          params: {
            pageIndex: this.page,
            pageSize: this.limit,
            startTime: this.value1[0],
            endTime: this.value1[1],
            // from: this.dateValue[0],
            // to: this.dateValue[1],
            type: this.tableType,
          },
        })
        .then((res) => {
          this.tableData = res.data.data.items;
          this.total = res.data.data.total;
          console.log(this.tableData);
        });
    },
    sizeChangeHandle(val) {
      // console.log(val);
      this.limit = val;
      this.page = 1;
      this.getDataList();
    },
    currentChangeHandle(val) {
      this.page = val;
      this.getDataList();
    },
    getTransaction(id, type) {
      this.transactionId = "";
      this.chaincodename = "";
      this.createdt = "";
      this.tokenId = "";
      this.owner = "";
      this.tokenURL = "";
      this.status = "";
      this.$http
        .get(this.$http.baseURL2 + "/nfe/sync/tradinglist", {
          params: {
            chaixTxId: id,
            // type:type
          },
        })
        .then((res) => {
          if (res.data.data) {
            this.transactionId = res.data.data.chain_tx_id;
            this.chaincodename = res.data.data.chaincodename;
            this.createdt = res.data.data.created_time;
            this.tokenId = res.data.data.token_id;
            this.owner = res.data.data.token_name;
            this.tokenURL = res.data.data.token_uri;
            this.status = res.data.data.status;
            this.burn = res.data.data.burn;
          } else {
            // this.dialogTableVisible = true
          }
          this.dialogTableVisible = true;
          console.log(this.transactionId);
        });
    },
    clickCopy() {
      new Clipboard(".tag-read").on("success", (e) => {
        // console.log('复制成功')
        new Clipboard(".tag-read").destroy(); // 释放内存
      });
      new Clipboard(".tag-read").on("error", (e) => {
        // console.log('不支持复制,该浏览器不支持自动复制')
        new Clipboard(".tag-read").destroy(); // 释放内存
      });
    },
  },
};
</script>

<style scoped lang="scss">
.home {
  .mainHead {
    margin-top: 0px;
    height: 70px;
    background-color: #fff;
    width: 100%;
    position: fixed;
    z-index: 10;
    top: 0;
    .head {
      display: flex;
      justify-content: space-between;
      // margin: 0 auto;
      // max-width: 1200px;
      .headLeft {
        cursor: pointer;
        display: flex;
        margin-top: 20px;
        img {
          width: 30px;
          height: 30px;
        }
        div {
          width: 100px;
          font-size: 16px;
          font-weight: bolder;
          // margin-left: 10px;
          line-height: 30px;
          font-family: "黑体";
          /*color: #1270b9;*/
          color: rgb(44, 37, 37);
        }
      }
      .headRight {
        display: flex;
        margin: 15px 0px 0px 0px;
        /deep/ .el-input-group > .el-input__inner {
          background-color: #f1f1f1;
        }
        /deep/ .el-input__inner {
          border-color: transparent;
        }
        .elInput {
          width: 60%;
        }
      }
    }

    .echarts {
      max-width: 1200px;
      margin: 10px auto;
      display: flex;

      .echart {
        background: white;
        /*width: 50%;*/
        width: 50%;
        height: 250px;
        margin-right: 10px;
        // padding-top: 20px;

        &:last-child {
          margin-right: 0;
        }

        div {
          width: 100%;
          height: 100%;
        }
      }
    }

    .table {
      background-color: white;
      padding: 10px 0px 0 0px;
      margin: 20px auto;
      max-width: 1200px;
      padding-bottom: 40px;

      .el-date-editor--datetimerange.el-input__inner {
        height: 50px;
      }
      .el-range-editor.el-input__inner {
        padding: 0px;
      }
      /deep/ .el-date-editor .el-range-separator {
        line-height: 50px;
      }
      /deep/ .el-select .el-input__inner {
        height: 50px;
      }
      /deep/ .el-date-editor .el-range-input {
        height: 18px;
        font-size: 18px;
        font-family: Source Han Sans CN-Light, Source Han Sans CN;
        font-weight: 300;
        color: #bbbbbb;
        margin-left: 20px;
      }

      /deep/ .el-icon-time:before {
        font-size: 22px;
        line-height: 50px;
        padding-left: 20px;
      }
      div {
        text-align: left;
        margin: 10px 0px;

        .el-select {
          /deep/ .el-input--suffix .el-input__inner {
            background-color: #9494d3;
            color: #fff;
          }

          /deep/ .el-input__inner {
            border-color: transparent;
          }
        }

        /deep/ .el-date-editor--datetimerange.el-input__inner {
          border-color: rgba(148, 148, 211, 1);
        }
      }

      .yuan {
        height: 10px;
        width: 10px;
        border-radius: 50%;
        background-color: rgba(64, 179, 148, 1);
      }
    }
  }
  .contene {
    /*background: url("./../assets/previewBG.gif") no-repeat center center;*/
    /*background-size: 100% 100%;*/
    /*background-color: white;*/
    height: 200px;
    margin: 0 auto 50px auto;
    width: 100%;
    // background-color: rgba(94, 33, 223, 0.5);
    background: linear-gradient(top, #7874ff, #dab4fe);
    .preview {
      /*margin: 0 auto 50px auto;*/
      /*max-width: 1200px;*/
      /*padding: 36px;*/
      margin-top: 20px;
      color: #fff;
      text-align: left;
      ul {
        display: flex;
        justify-content: center;
        i {
          height: 45px;
          width: 1px;
          background-color: rgba(255, 255, 255, 0.5);
          margin-top: 70px;
          margin-bottom: 92px;
        }
        li {
          display: flex;
          flex-direction: column;
          justify-content: center;
          width: 300px;
          text-align: center;
          height: 200px;
          &:last-child {
            margin-right: 0;
          }
          /*border-right: 1px solid #ffffff;*/
          /*margin-right: 20px;*/
          /*&:last-child { border-right: 0; }*/
          .img1 {
            margin-left: 10px;
            width: 20px;
            height: 20px;
            background: url("./../assets/preview1.png") no-repeat;
            background-size: 20px;
          }
          .img2 {
            margin-left: 10px;
            width: 20px;
            height: 20px;
            background: url("./../assets/preview2.png") no-repeat;
            background-size: 20px;
          }
          .img3 {
            margin-left: 10px;
            width: 20px;
            height: 20px;
            background: url("./../assets/preview3.png") no-repeat;
            background-size: 20px;
          }
          .img4 {
            margin-left: 10px;
            width: 20px;
            height: 20px;
            background: url("./../assets/preview4.png") no-repeat;
            background-size: 20px;
          }
          .name {
            // margin-top: 50px;
            font-size: 1.2em;
            background: no-repeat left center;
            background-size: 14px;
            // margin-bottom: 10px;
          }
          .value {
            font-size: 2em;
            font-weight: bold;
            // margin-bottom: 12px;
            // margin-top: 10px;
          }
        }
      }
      .previewImg {
        .img {
          width: 100px;
          height: 100px;
          background: url("./../assets/preview5.png") no-repeat;
          background-size: 100px;
        }
        .connect {
          width: 100px;
          text-align: center;
        }
      }
    }
    .echarts {
      max-width: 1200px;
      margin: 20px auto;
      display: flex;
      .echart {
        background: white;
        /*width: 50%;*/
        width: 50%;
        height: 250px;
        margin-right: 10px;
        padding-top: 20px;
        &:last-child {
          margin-right: 0;
        }
        div {
          width: 100%;
          height: 100%;
        }
      }
    }
    .table {
      background-color: white;
      padding: 10px 0px 0 0px;
      margin: 20px auto;
      max-width: 1200px;
      padding-bottom: 40px;
      .div {
        text-align: left;
        margin: 10px 0px;
        display: flex;
        justify-content: space-between;
        .el-select {
          /deep/ .el-input--suffix .el-input__inner {
            background-color: #9494d3;
            color: #fff;
          }
          /deep/ .el-input__inner {
            border-color: transparent;
          }
        }
        /deep/ .el-date-editor--datetimerange.el-input__inner {
          border-color: rgba(148, 148, 211, 1);
        }
      }
      .tel {
        display: flex;
        .el-select {
          /deep/ .el-input--suffix .el-input__inner {
            background-color: #9494d3;
            color: #fff;
          }
        }
      }
      .yuan {
        height: 10px;
        width: 10px;
        border-radius: 50%;
        background-color: rgba(64, 179, 148, 1);
      }
    }
    #echartsfive {
      width: 100%;
      height: 300px;
      background-color: white;
    }
    #echartssix {
      width: 100%;
      height: 300px;
      background-color: white;
    }
    #echartssenve {
      width: 100%;
      height: 300px;
      background-color: white;
    }
    #echartseight {
      width: 100%;
      height: 300px;
      background-color: white;
    }
  }
}
</style>
